/**
 * preorder-widget.js — Amalgamous Preorder
 * Remplace Timesact. Gère l'affichage des selling plans sur la fiche produit.
 * 1 variante peut avoir plusieurs selling plans au choix.
 */
(function () {
  'use strict';

  // ─── Sélecteurs (adaptés au thème Shopiweb) ───────────────────────────────
  // :not(.secondary-atc-form) exclut les formulaires ATC secondaires embarqués
  // (ex: bloc "Set complet") pour ne jamais cibler le mauvais bouton/formulaire.
  const SEL_FORM           = 'form[action*="/cart/add"]:not(.secondary-atc-form)';
  const SEL_BUY_BUTTONS    = '.product-buy-buttons';
  const SEL_BTN            = '.btn-atc:not(.full-set-atc-btn)';
  const SEL_BTN_TEXT       = '.btn-atc-text';
  const SEL_GALLERY        = '.product-gallery-wrapper';
  const SEL_FULL_SET_BTN   = '.full-set-atc-btn';

  const WIDGET_ID  = 'amalgamous-preorder-widget';
  const RIBBON_ID  = 'amalgamous-ribbon';
  const STYLES_ID  = 'amalgamous-styles';

  // ─── Traductions ──────────────────────────────────────────────────────────
  var TRANSLATIONS = {
    fr: { preorder: 'Pré-Commander',  label: 'Pré-Commande',  ribbon: 'PRE-COMMANDE'  },
    en: { preorder: 'Pre-Order',      label: 'Pre-Order',     ribbon: 'PRE-ORDER'     },
    es: { preorder: 'Pre-Ordenar',    label: 'Pre-Orden',     ribbon: 'PRE-ORDEN'     },
    de: { preorder: 'Vorbestellen',   label: 'Vorbestellung', ribbon: 'VORBESTELLUNG' },
    it: { preorder: 'Pre-Ordinare',   label: 'Pre-Ordine',    ribbon: 'PRE-ORDINE'    },
    nl: { preorder: 'Voorbestellen',  label: 'Voorbestelling',ribbon: 'VOORBESTELLING'},
    pt: { preorder: 'Pré-Encomendar', label: 'Pré-Encomenda', ribbon: 'PRÉ-ENCOMENDA' },
    sv: { preorder: 'Förbeställ',     label: 'Förbeställning',ribbon: 'FÖRBESTÄLLNING'},
    da: { preorder: 'Forudbestil',    label: 'Forudbestilling',ribbon: 'FORUDBESTILLING'},
    pl: { preorder: 'Zamów W Przedsprzedaży', label: 'Przedsprzedaż', ribbon: 'PRZEDSPRZEDAŻ' },
    ro: { preorder: 'Precomandă',     label: 'Precomandă',    ribbon: 'PRECOMANDĂ'    },
    el: { preorder: 'Προπαραγγελία',  label: 'Προπαραγγελία', ribbon: 'ΠΡΟΠΑΡΑΓΓΕΛΙΑ' },
    hu: { preorder: 'Előrendelés',    label: 'Előrendelés',   ribbon: 'ELŐRENDELÉS'   },
    sk: { preorder: 'Pred-objednať',  label: 'Pred-objednávka',ribbon: 'PRED-OBJEDNÁVKA'},
    lt: { preorder: 'Išankstinis Užsakymas', label: 'Išankstinis Užsakymas', ribbon: 'IŠANKSTINIS' },
    et: { preorder: 'Eeltellimus',    label: 'Eeltellimus',   ribbon: 'EELTELLIMUS'   },
    ga: { preorder: 'Réamhordú',      label: 'Réamhordú',     ribbon: 'RÉAMHORDÚ'     },
    lb: { preorder: 'Virbestallung',  label: 'Virbestallung', ribbon: 'VIRBESTALLUNG' },
  };

  var _locale    = (window.Shopify && window.Shopify.locale && window.Shopify.locale.split('-')[0]) || 'fr';
  var _t         = TRANSLATIONS[_locale] || TRANSLATIONS['fr'];
  var _urlPrefix = (function () {
    var m = window.location.pathname.match(/^(\/[a-z]{2}(-[a-z]{2})?)\//i);
    return m ? m[1] : '';
  })();

  // Surcharge manuelle toujours possible via window.AmalgamousPreorder
  var _cfg         = window.AmalgamousPreorder || {};
  var TEXT_PREORDER = _cfg.textPreorder || _t.preorder;
  var TEXT_LABEL    = _cfg.textLabel    || _t.label;
  var TEXT_RIBBON   = _cfg.textRibbon   || _t.ribbon;

  // Plans dont le nom contient ce marqueur sont "fake" : affichés normalement
  // mais ajoutés au panier sans selling_plan (compatibilité PayPal 4X).
  var FAKE_PLAN_MARKER = '#fake#';

  // Plan actuellement sélectionné sur la fiche produit (pour le failsafe submit)
  var _selectedPlanId = null;

  // ─── Plan fake : sauvegarde locale pour l'affichage panier ───────────────
  function saveFakeAtc(variantId, plan) {
    try {
      var arr = JSON.parse(localStorage.getItem('amalgamous_fake_atc') || '[]');
      arr = arr.filter(function (e) { return e.variantId !== variantId; });
      arr.push({
        variantId       : variantId,
        planLabel       : plan.label,
        planName        : plan.name.replace(/#fake#\s*/gi, '').trim(),
        planDescription : plan.description,
      });
      localStorage.setItem('amalgamous_fake_atc', JSON.stringify(arr.slice(-20)));
    } catch (e) {}
  }

  // Injecte une line item property visible dans le form pour afficher le plan fake au checkout
  function injectFakePropToForm(form, plan) {
    if (!form) return;
    // Supprimer les propriétés fake précédentes pour éviter les doublons
    form.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = 'properties[' + plan.label + ']';
    inp.value = plan.description || '';
    inp.setAttribute('data-amalgamous-fake-prop', '1');
    form.appendChild(inp);
  }

  // ─── État interne ─────────────────────────────────────────────────────────
  let productData = null;   // données JSON du produit
  var _closeOptions = null; // handler document click pour fermer le panneau plans
  var _fakePlanIds  = null; // IDs des plans fake page produit (depuis locale par défaut)
  var _fakePlanIdsByHandle = {}; // cache handle → [ids] pour les cartes catalogue

  // ─── Démarrage ────────────────────────────────────────────────────────────
  function boot() {
    if (!window.location.pathname.includes('/products/')) return;

    // Lire les données depuis les attributs Liquid embarqués (locale correcte, pas de fetch)
    // data-sp-groups / data-catalog-variants sont posés par product-block-buy-buttons.liquid
    var buyEl = document.querySelector('.product-buy-buttons[data-sp-groups]');
    // Extraire le handle pour le fetch locale par défaut
    var handleEl = document.querySelector('[data-product-handle]');
    var defaultHandle = handleEl
      ? handleEl.dataset.productHandle
      : window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];

    // Fetch locale par défaut en parallèle pour détecter les plans fake (noms non traduits)
    if (defaultHandle) {
      fetch('/products/' + defaultHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          _fakePlanIds = [];
          (data.selling_plan_groups || []).forEach(function (g) {
            (g.selling_plans || []).forEach(function (p) {
              if ((p.name || '').indexOf(FAKE_PLAN_MARKER) !== -1) {
                _fakePlanIds.push(p.id);
              }
            });
          });
        })
        .catch(function () {});
    }

    if (buyEl && buyEl.dataset.spGroups && buyEl.dataset.catalogVariants) {
      try {
        var spGroups = JSON.parse(buyEl.dataset.spGroups);
        var variants = JSON.parse(buyEl.dataset.catalogVariants);
        productData = {
          id       : parseInt(buyEl.dataset.productId, 10),
          variants : variants,
          selling_plan_groups: spGroups,
        };
        injectStyles();
        var variantId = getCurrentVariantId();
        if (variantId) updateWidget(variantId);
      } catch (e) {
        console.warn('[Amalgamous Preorder] erreur parsing data attributes:', e);
      }
    } else {
      // Fallback : fetch (locale par défaut uniquement — peut retourner du texte non traduit)
      fetch('/products/' + defaultHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          productData = data;
          injectStyles();
          var variantId = getCurrentVariantId();
          if (variantId) updateWidget(variantId);
        })
        .catch(function (e) { console.warn('[Amalgamous Preorder]', e); });
    }

    // Écouter les changements de variante du thème Shopiweb
    window.addEventListener('variantChange.shopiweb.product', function (e) {
      updateWidget(e.detail.id);
    });

    // Failsafe : resynchroniser le selling_plan au moment du submit
    // (le listener async de product.js peut remplacer des éléments DOM après notre mise à jour)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches(SEL_FORM)) return;
      if (!productData) return;
      var vid = getCurrentVariantId();
      if (!vid) return;
      var plans = getPlansForVariant(vid);
      var spInput = form.querySelector('[name="selling_plan"]');
      if (!spInput) return;
      if (plans.length) {
        var sel = null;
        for (var fi = 0; fi < plans.length; fi++) {
          if (plans[fi].planId === _selectedPlanId) { sel = plans[fi]; break; }
        }
        if (!sel) sel = plans[0];
        if (sel.isFake) {
          spInput.disabled = true;
          spInput.value = '';
          saveFakeAtc(vid, sel);
          injectFakePropToForm(form, sel);
        } else {
          spInput.disabled = false;
          spInput.value = String(sel.planId);
        }
      } else {
        spInput.disabled = true;
        spInput.value = '';
      }
    }, true); // capture phase pour s'exécuter avant handleAddToCartFormSubmit
  }

  // ─── Utilitaires ──────────────────────────────────────────────────────────
  function getCurrentVariantId() {
    var form = document.querySelector(SEL_FORM);
    var val  = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
    return val ? parseInt(val, 10) : null;
  }

  function getPlansForVariant(variantId, pd, cardFakePlanIds) {
    var data = pd || productData;
    if (!data) return [];
    var variant = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) {
        variant = data.variants[i];
        break;
      }
    }
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return [];
    }

    // Dédupliquer par groupe : 1 groupe = 1 option dans le sélecteur
    var seen   = {};
    var result = [];

    for (var j = 0; j < variant.selling_plan_allocations.length; j++) {
      var alloc   = variant.selling_plan_allocations[j];
      var groupId = alloc.selling_plan_group_id;

      if (seen[groupId]) continue;
      seen[groupId] = true;

      var group = null;
      if (data.selling_plan_groups) {
        for (var k = 0; k < data.selling_plan_groups.length; k++) {
          if (data.selling_plan_groups[k].id === groupId) {
            group = data.selling_plan_groups[k];
            break;
          }
        }
      }

      var plan = null;
      if (group && group.selling_plans) {
        for (var l = 0; l < group.selling_plans.length; l++) {
          if (group.selling_plans[l].id === alloc.selling_plan_id) {
            plan = group.selling_plans[l];
            break;
          }
        }
      }

      var planName = (plan && plan.name) || (group && group.name) || 'Plan';
      result.push({
        planId      : alloc.selling_plan_id,
        groupId     : groupId,
        label       : (plan && plan.options && plan.options[0] && plan.options[0].value) || (group && group.name) || 'Plan',
        name        : planName,
        description : (plan && plan.description) || '',
        isFake      : planName.indexOf(FAKE_PLAN_MARKER) !== -1 ||
                      (_fakePlanIds !== null && _fakePlanIds.indexOf(alloc.selling_plan_id) !== -1) ||
                      (cardFakePlanIds && cardFakePlanIds.indexOf(alloc.selling_plan_id) !== -1),
      });
    }

    return result;
  }

  // ─── Cycle de vie du widget ───────────────────────────────────────────────
  function isVariantAvailable(variantId) {
    if (!productData) return true;
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].id === variantId) return productData.variants[i].available;
    }
    return true;
  }

  function updateWidget(variantId) {
    var plans = getPlansForVariant(variantId);

    if (!plans.length || !isVariantAvailable(variantId)) {
      _selectedPlanId = null;
      removeWidget();
      restoreButton();
      removeBadges();
      return;
    }

    _selectedPlanId = plans[0].planId;
    renderWidget(plans);
    modifyButton();
    renderBadges();
  }

  // ─── Sélecteur de plans ───────────────────────────────────────────────────
  function renderWidget(plans) {
    var form = document.querySelector(SEL_FORM);
    if (!form) return;

    // S'assurer que l'input selling_plan existe et est actif
    var spInput = form.querySelector('[name="selling_plan"]');
    if (!spInput) {
      spInput = document.createElement('input');
      spInput.type  = 'hidden';
      spInput.name  = 'selling_plan';
      form.appendChild(spInput);
    }
    spInput.disabled = false;
    spInput.value    = String(plans[0].planId);

    // Supprimer le widget existant
    var existing = document.getElementById(WIDGET_ID);
    if (existing) existing.parentNode.removeChild(existing);

    var firstDesc = plans[0].description || '';

    var widget = document.createElement('div');
    widget.id = WIDGET_ID;

    // ── Plan unique : pas de sélecteur, selling plan appliqué silencieusement ──
    if (plans.length === 1) {
      if (_closeOptions) { document.removeEventListener('click', _closeOptions); _closeOptions = null; }
      if (firstDesc) {
        var msgEl = document.createElement('div');
        msgEl.className = 'amalgamous-plan-message';
        msgEl.textContent = firstDesc;
        widget.appendChild(msgEl);
      }
    } else {
      // ── Toggle button (remplace <select> — évite que le thème le convertisse) ──
      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'amalgamous-plan-toggle';
      toggleBtn.textContent = plans[0].label;

      // ── Panneau d'options (sibling du selectorDiv, pas à l'intérieur) ──
      var optionsDiv = document.createElement('div');
      optionsDiv.className = 'amalgamous-plan-options';
      optionsDiv.style.display = 'none';

      // ── Message ──
      var msgEl = document.createElement('div');
      msgEl.className = 'amalgamous-plan-message';
      if (firstDesc) { msgEl.textContent = firstDesc; }
      else           { msgEl.style.display = 'none'; }

      // Construire les boutons d'options
      function buildOptions() {
        optionsDiv.innerHTML = '';
        for (var i = 0; i < plans.length; i++) {
          (function (plan) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'amalgamous-plan-option';
            btn.textContent = plan.label;
            btn.addEventListener('click', function () {
              _selectedPlanId = plan.planId;
              if (plan.isFake) {
                spInput.disabled = true;
                spInput.value    = '';
              } else {
                spInput.disabled = false;
                spInput.value    = String(plan.planId);
              }
              toggleBtn.textContent = plan.label;
              optionsDiv.style.display = 'none';
              var desc = plan.description || '';
              if (desc) { msgEl.textContent = desc; msgEl.style.display = ''; }
              else       { msgEl.textContent = ''; msgEl.style.display = 'none'; }
            });
            optionsDiv.appendChild(btn);
          })(plans[i]);
        }
      }
      buildOptions();

      // Ouvrir/fermer au clic du toggle
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        optionsDiv.style.display = optionsDiv.style.display === 'none' ? 'block' : 'none';
      });

      // Fermer si clic en dehors (une seule instance du handler)
      if (_closeOptions) document.removeEventListener('click', _closeOptions);
      _closeOptions = function () { optionsDiv.style.display = 'none'; };
      document.addEventListener('click', _closeOptions);

      // ── Assemblage sélecteur ──
      var selectorDiv = document.createElement('div');
      selectorDiv.className = 'amalgamous-plan-selector';
      var labelEl = document.createElement('span');
      labelEl.className   = 'amalgamous-plan-label';
      labelEl.textContent = TEXT_LABEL;
      selectorDiv.appendChild(labelEl);
      selectorDiv.appendChild(toggleBtn);

      widget.appendChild(selectorDiv);
      widget.appendChild(optionsDiv);
      widget.appendChild(msgEl);
    }

    // Insérer AVANT .product-buy-buttons (au-dessus du sélecteur qté + bouton)
    var buyButtons = form.querySelector(SEL_BUY_BUTTONS);
    if (buyButtons) {
      form.insertBefore(widget, buyButtons);
    } else {
      var atcBtn = form.querySelector(SEL_BTN);
      if (atcBtn) {
        atcBtn.parentNode.insertBefore(widget, atcBtn);
      } else {
        form.appendChild(widget);
      }
    }
  }

  function removeWidget() {
    var w = document.getElementById(WIDGET_ID);
    if (w) w.parentNode.removeChild(w);

    // Désactiver l'input selling_plan pour qu'il ne soit pas envoyé
    var form = document.querySelector(SEL_FORM);
    if (form) {
      var spInput = form.querySelector('[name="selling_plan"]');
      if (spInput) {
        spInput.disabled = true;
        spInput.value    = '';
      }
    }
  }

  // ─── Modification du bouton ATC ───────────────────────────────────────────
  // Pas de MutationObserver (conflit avec les apps de traduction type Hextom).
  // Le texte est repositionné via les événements variantChange et updateWidget.
  // On remplace aussi data-text-add-to-cart pour que product.js restaure "Pré-Commander"
  // après son animation (il lit l'attribut à t=2000ms, pas à t=0).
  var _origBtnAtcText = null;
  // Bouton secondaire (ex: bloc "Set complet") : suit le statut précommande
  // du produit de BASE affiché sur la page, jamais celui du produit lié.
  var _origFullSetBtnText = null;

  function modifyButton() {
    var btn = document.querySelector(SEL_BTN);
    if (!btn) return;
    if (!_origBtnAtcText) _origBtnAtcText = btn.getAttribute('data-text-add-to-cart') || '';
    btn.setAttribute('data-text-add-to-cart', TEXT_PREORDER);
    var textEl = btn.querySelector(SEL_BTN_TEXT);
    if (textEl) {
      textEl.textContent = TEXT_PREORDER;
    } else {
      var tn = Array.from(btn.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (tn) tn.textContent = TEXT_PREORDER;
      else btn.insertBefore(document.createTextNode(TEXT_PREORDER), btn.firstChild);
    }

    var fullSetBtn = document.querySelector(SEL_FULL_SET_BTN);
    if (fullSetBtn) {
      if (!_origFullSetBtnText) _origFullSetBtnText = fullSetBtn.getAttribute('data-text-add-to-cart') || '';
      fullSetBtn.setAttribute('data-text-add-to-cart', TEXT_PREORDER);
      var fullSetTextEl = fullSetBtn.querySelector(SEL_BTN_TEXT);
      if (fullSetTextEl) fullSetTextEl.textContent = TEXT_PREORDER;
    }
  }

  function restoreButton() {
    var btn = document.querySelector(SEL_BTN);
    if (btn && _origBtnAtcText) btn.setAttribute('data-text-add-to-cart', _origBtnAtcText);
    var textEl = document.querySelector(SEL_BTN + ' ' + SEL_BTN_TEXT);
    if (textEl && textEl.textContent === TEXT_PREORDER) {
      textEl.textContent =
        (window.theme && window.theme.product && window.theme.product.addToCart) ||
        'Ajouter au panier';
    }

    var fullSetBtn = document.querySelector(SEL_FULL_SET_BTN);
    if (fullSetBtn && _origFullSetBtnText) {
      fullSetBtn.setAttribute('data-text-add-to-cart', _origFullSetBtnText);
      var fullSetTextEl = fullSetBtn.querySelector(SEL_BTN_TEXT);
      if (fullSetTextEl && fullSetTextEl.textContent === TEXT_PREORDER) {
        fullSetTextEl.textContent = _origFullSetBtnText;
      }
    }
  }

  // ─── Ribbon image produit ─────────────────────────────────────────────────
  function renderBadges() {
    var wrapper = document.querySelector(SEL_GALLERY);
    if (!wrapper) return;
    removeBadges();
    // Garantir que la galerie est positionnée pour que le ruban reste à l'intérieur (bug mobile)
    // On ne force 'relative' que si l'élément est 'static' pour ne pas casser le layout desktop
    if (window.getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }
    var ribbon = document.createElement('div');
    ribbon.id = RIBBON_ID;
    ribbon.innerHTML = '<span>' + TEXT_RIBBON + '</span>';
    wrapper.appendChild(ribbon);
  }

  function removeBadges() {
    var r = document.getElementById(RIBBON_ID);
    if (r) r.parentNode.removeChild(r);
  }

  // ─── Styles CSS injectés ──────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById(STYLES_ID)) return;
    var style = document.createElement('style');
    style.id = STYLES_ID;
    style.textContent = [
      /* Sélecteur de plan — identique au input-group natif Shopiweb */
      '#amalgamous-preorder-widget {',
      '  margin-bottom: 1rem;',
      '  position: relative;',
      '}',
      /* Wrapper = input-group Bootstrap */
      '.amalgamous-plan-selector {',
      '  display: flex;',
      '  flex-wrap: wrap;',
      '  align-items: stretch;',
      '  width: 100%;',
      '}',
      /* Label = input-group-text Bootstrap */
      '.amalgamous-plan-label {',
      '  display: flex;',
      '  align-items: center;',
      '  padding: 0.375rem 0.75rem;',
      '  font-size: 1rem;',
      '  font-weight: 400;',
      '  line-height: 1.5;',
      '  color: var(--bs-body-color, #212529);',
      '  text-align: center;',
      '  white-space: nowrap;',
      '  background-color: var(--bs-tertiary-bg, #f8f9fa);',
      '  border: var(--bs-border-width, 1px) solid var(--bs-border-color, #dee2e6);',
      '  border-radius: var(--bs-border-radius, 0.375rem);',
      '  border-top-right-radius: 0;',
      '  border-bottom-right-radius: 0;',
      '  flex-shrink: 0;',
      '}',
      /* Toggle = form-select Bootstrap */
      '.amalgamous-plan-toggle {',
      '  display: block;',
      '  flex: 1 1 auto;',
      '  min-width: 0;',
      '  width: 1%;',
      '  padding: 0.375rem 2.25rem 0.375rem 0.75rem;',
      '  font-size: 1rem;',
      '  font-weight: 400;',
      '  line-height: 1.5;',
      '  color: var(--bs-body-color, #212529);',
      '  background-color: var(--bs-form-control-bg, #fff);',
      '  background-image: url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'%3e%3cpath fill=\'none\' stroke=\'%23343a40\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'m2 5 6 6 6-6\'/%3e%3c/svg%3e");',
      '  background-repeat: no-repeat;',
      '  background-position: right 0.75rem center;',
      '  background-size: 16px 12px;',
      '  border: var(--bs-border-width, 1px) solid var(--bs-border-color, #dee2e6);',
      '  border-radius: var(--bs-border-radius, 0.375rem);',
      '  border-top-left-radius: 0;',
      '  border-bottom-left-radius: 0;',
      '  appearance: none;',
      '  -webkit-appearance: none;',
      '  cursor: pointer;',
      '  text-align: left;',
      '  outline: none;',
      '}',
      '.amalgamous-plan-toggle:focus {',
      '  border-color: var(--bs-primary, #0d6efd);',
      '  box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb, 13,110,253), 0.25);',
      '}',
      /* Dropdown options */
      '.amalgamous-plan-options {',
      '  position: absolute;',
      '  left: 0;',
      '  right: 0;',
      '  z-index: 200;',
      '  background-color: var(--bs-body-bg, #fff);',
      '  border: var(--bs-border-width, 1px) solid var(--bs-border-color, #dee2e6);',
      '  border-radius: var(--bs-border-radius, 0.375rem);',
      '  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15);',
      '  overflow: hidden;',
      '}',
      '.amalgamous-plan-option {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 0.375rem 0.75rem;',
      '  font-size: 1rem;',
      '  font-weight: 400;',
      '  line-height: 1.5;',
      '  color: var(--bs-body-color, #212529);',
      '  background-color: transparent;',
      '  border: none;',
      '  cursor: pointer;',
      '  text-align: left;',
      '  white-space: normal;',
      '}',
      '.amalgamous-plan-option:hover {',
      '  background-color: var(--bs-tertiary-bg, #f8f9fa);',
      '}',
      '.amalgamous-plan-message {',
      '  font-size: 0.875rem;',
      '  color: var(--bs-secondary-color, #6c757d);',
      '  margin-top: 0.375rem;',
      '  padding: 0.375rem 0.75rem;',
      '  background-color: var(--bs-tertiary-bg, #f8f9fa);',
      '  border-radius: var(--bs-border-radius, 0.375rem);',
      '  border-left: 3px solid var(--bs-primary, #0d6efd);',
      '}',
      '.amalgamous-cart-message {',
      '  font-size: 12px;',
      '  color: #666;',
      '  margin-top: 3px;',
      '}',
      '.amalgamous-fake-plan-label {',
      '  font-size: 0.8em;',
      '  color: var(--bs-secondary-color, #6c757d);',
      '  margin-top: 2px;',
      '}',
      /* Items du dropdown catalogue selling plans */
      '.amalgamous-dropdown-item {',
      '  padding: 10px 16px;',
      '  font-size: 13px;',
      '  font-weight: 500;',
      '  line-height: 1.4;',
      '  display: block;',
      '  width: 100%;',
      '  text-align: center;',
      '  white-space: normal;',
      '}',
      '@media (max-width: 767px) {',
      '  .amalgamous-dropdown-item {',
      '    text-align: left;',
      '  }',
      '}',

      /* Ribbon PRE-ORDER — inspiré du rendu Timesact */
      '#amalgamous-ribbon,',
      '.amalgamous-ribbon-card {',
      '  position: absolute;',
      '  top: -5px;',
      '  right: -5px;',
      '  width: 75px;',
      '  height: 75px;',
      '  text-align: right;',
      '  overflow: hidden;',
      '  z-index: 20;',
      '  pointer-events: none;',
      '}',

      '#amalgamous-ribbon span,',
      '.amalgamous-ribbon-card span {',
      '  position: absolute;',
      '  top: 19px;',
      '  right: -20px;',
      '  display: block;',
      '  width: 100px;',
      '  background: #F6AB13;',
      '  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);',
      '  transform: rotate(45deg);',
      '  -webkit-transform: rotate(45deg);',
      '  text-align: center;',
      '  white-space: nowrap;',
      '  text-transform: uppercase;',
      '  line-height: 20px;',
      '  font-size: 7px;',
      '  font-weight: 800;',
      '  color: #fff;',
      '  letter-spacing: 0.8px;',
      '  font-family: inherit;',
      '}',

      '#amalgamous-ribbon span::before,',
      '.amalgamous-ribbon-card span::before {',
      '  content: "";',
      '  position: absolute;',
      '  left: 0;',
      '  top: 100%;',
      '  z-index: -1;',
      '  border-left: 3px solid #888888;',
      '  border-right: 3px solid transparent;',
      '  border-bottom: 3px solid transparent;',
      '  border-top: 3px solid #888888;',
      '}',

      '#amalgamous-ribbon span::after,',
      '.amalgamous-ribbon-card span::after {',
      '  content: "";',
      '  position: absolute;',
      '  right: 0;',
      '  top: 100%;',
      '  z-index: -1;',
      '  border-left: 3px solid transparent;',
      '  border-right: 3px solid #888888;',
      '  border-bottom: 3px solid transparent;',
      '  border-top: 3px solid #888888;',
      '}',

      '@media (max-width: 767px) {',
      '  #amalgamous-ribbon,',
      '  .amalgamous-ribbon-card {',
      '    width: 60px;',
      '    height: 60px;',
      '  }',
      '  #amalgamous-ribbon span,',
      '  .amalgamous-ribbon-card span {',
      '    top: 15px;',
      '    right: -17px;',
      '    width: 84px;',
      '    line-height: 16px;',
      '    font-size: 6px;',
      '    letter-spacing: 0.6px;',
      '  }',
      '}',

      /* Ruban pour les cartes du search drawer (images ~110px, échelle 0.8×) */
      '#search-predictive .amalgamous-ribbon-card {',
      '  width: 46px;',
      '  height: 46px;',
      '  top: -5px;',
      '  right: -5px;',
      '}',
      '#search-predictive .amalgamous-ribbon-card span {',
      '  top: 12px;',
      '  right: -13px;',
      '  width: 62px;',
      '  line-height: 13px;',
      '  font-size: 5px;',
      '  letter-spacing: 0.5px;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  // ─── Panier : remplace le nom interne par l'option client + message ─────────
  function updateCartPlanLabels() {
    var _cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(_cartRoot + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fakeAtcs = {};
        try {
          var stored = JSON.parse(localStorage.getItem('amalgamous_fake_atc') || '[]');
          for (var s = 0; s < stored.length; s++) fakeAtcs[stored[s].variantId] = stored[s];
        } catch (e) {}

        // Construire la map : key → { option, description, internalName, isFake }
        var keyMap = {};
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.selling_plan_allocation) {
            var sp = item.selling_plan_allocation.selling_plan;
            keyMap[item.key] = {
              option       : (sp.options && sp.options[0] && sp.options[0].value) || sp.name,
              description  : sp.description || '',
              internalName : sp.name,
              isFake       : false,
            };
          } else if (fakeAtcs[item.variant_id]) {
            var fk = fakeAtcs[item.variant_id];
            keyMap[item.key] = {
              option       : fk.planLabel,
              description  : fk.planDescription,
              internalName : null,
              isFake       : true,
            };
          }
        }

        if (!Object.keys(keyMap).length) return;

        document.querySelectorAll('[data-cart-line-item]').forEach(function (lineEl) {
          var key  = lineEl.dataset.lineItemKey;
          var plan = keyMap[key];
          if (!plan) return;

          // Éviter de patcher deux fois le même DOM node
          if (lineEl.dataset.amalgamousPatched === '1') return;

          // Plan fake : la line item property gère l'affichage dans le panier et le checkout
          if (plan.isFake) return;

          // 1) Chercher un élément avec classe "selling-plan"
          var target = lineEl.querySelector('[class*="selling-plan"]') ||
                       lineEl.querySelector('[class*="selling_plan"]');

          // 2) Fallback : chercher un nœud feuille dont le texte = nom interne
          if (!target && plan.internalName) {
            var all = lineEl.querySelectorAll('*');
            for (var j = 0; j < all.length; j++) {
              if (all[j].children.length === 0 &&
                  all[j].textContent.trim() === plan.internalName) {
                target = all[j];
                break;
              }
            }
          }

          if (!target) return;

          lineEl.dataset.amalgamousPatched = '1';
          target.textContent = plan.option;

          if (plan.description) {
            var msg = document.createElement('div');
            msg.className   = 'amalgamous-cart-message';
            msg.textContent = plan.description;
            target.parentNode.insertBefore(msg, target.nextSibling);
          }
        });
      })
      .catch(function () {});
  }

  function bootCart() {
    updateCartPlanLabels();
    window.addEventListener('updated.shopiweb.cart', function () {
      // Nettoyer les fake props des formulaires après chaque ATC réussi
      document.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (el) {
        el.parentNode.removeChild(el);
      });
      updateCartPlanLabels();
    });
  }

  // ─── Pages catalogue / recherche : cartes produit ─────────────────────────
  function patchCatalogCard(card, product, fakePlanIds) {
    if (card.dataset.amalgamousCatalogPatched) return;
    card.dataset.amalgamousCatalogPatched = '1';

    // Masquer le sélecteur de variante natif — remplacé par le dropdown preorder
    var variantSelect = card.querySelector('select[name="id"]');
    if (variantSelect) variantSelect.style.display = 'none';

    var variants       = product.variants || [];
    var isMultiVariant = variants.length > 1;
    var atcBtn         = card.querySelector(SEL_BTN);
    var textEl         = atcBtn && atcBtn.querySelector(SEL_BTN_TEXT);

    // ── Helpers communs ───────────────────────────────────────────────────────
    function renameBtn() {
      if (textEl) {
        textEl.textContent = TEXT_PREORDER;
      } else if (atcBtn) {
        var tn = Array.from(atcBtn.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
        if (tn) tn.textContent = ' ' + TEXT_PREORDER;
        else atcBtn.insertBefore(document.createTextNode(TEXT_PREORDER), atcBtn.firstChild);
      }
      // Signal pour product.js : après l'animation ATC, remettre TEXT_PREORDER
      if (atcBtn) atcBtn.setAttribute('data-amalgamous-preorder', TEXT_PREORDER);
    }

    // Après l'animation ATC (product.js remet le texte original après 2s), remettre "Pré-Commander"
    window.addEventListener('updated.shopiweb.cart', function () {
      setTimeout(renameBtn, 2100);
    });

    function setupDropdown(menu) {
      if (atcBtn && !atcBtn.getAttribute('data-bs-toggle')) {
        atcBtn.setAttribute('data-bs-toggle', 'dropdown');
        atcBtn.setAttribute('aria-expanded', 'false');
        atcBtn.classList.add('dropdown-toggle');
        atcBtn.parentNode.classList.add('dropdown', 'dropup');
      }
      var dc = atcBtn && (atcBtn.closest('.dropdown') || atcBtn.parentNode);
      if (dc) dc.classList.add('dropup');
      var form = atcBtn && atcBtn.closest('form');
      if (form && !form.querySelector('[name="selling_plan"]')) {
        var sp = document.createElement('input');
        sp.type = 'hidden'; sp.name = 'selling_plan'; sp.value = '';
        form.appendChild(sp);
      }
      return menu;
    }

    function addRibbon() {
      // Collection : a.product-link — Search drawer : lien parent de l'image produit
      var imgWrapper = card.querySelector('a.product-link');
      if (!imgWrapper) {
        var imgEl = card.querySelector('img.product-item-img');
        if (imgEl) {
          imgWrapper = imgEl.closest('a');
          // <a> est display:inline par défaut — passer en inline-block pour que
          // position:relative crée un vrai contexte de positionnement
          if (imgWrapper && window.getComputedStyle(imgWrapper).display === 'inline') {
            imgWrapper.style.display = 'inline-block';
          }
        }
      }
      if (imgWrapper && !card.querySelector('.amalgamous-ribbon-card')) {
        if (window.getComputedStyle(imgWrapper).position === 'static') {
          imgWrapper.style.position = 'relative';
        }
        var ribbon = document.createElement('div');
        ribbon.className = 'amalgamous-ribbon-card';
        ribbon.innerHTML = '<span>' + TEXT_RIBBON + '</span>';
        imgWrapper.appendChild(ribbon);
      }
    }

    if (isMultiVariant) {
      // ── Multi-variante : Niveau 1 = variantes, Niveau 2 = selling plans ──────

      // Collecter toutes les variantes ayant des selling plans (OOS incluses, barrées)
      var allEntries = [];
      var hasAvailable = false;
      for (var i = 0; i < variants.length; i++) {
        var vp = getPlansForVariant(variants[i].id, product, fakePlanIds);
        if (!vp.length) continue;
        allEntries.push({ variant: variants[i], plans: vp, oos: !variants[i].available });
        if (variants[i].available) hasAvailable = true;
      }
      // Si aucune variante disponible → BIS prend le relais, on ne touche pas au bouton
      if (!hasAvailable) return;

      renameBtn();

      var menu = card.querySelector('.dropdown-menu');
      if (!menu && atcBtn) {
        menu = document.createElement('ul');
        menu.className = 'dropdown-menu shadow w-100';
        atcBtn.parentNode.appendChild(menu);
      }
      setupDropdown(menu);

      function buildLevel1() {
        if (!menu) return;
        menu.innerHTML = '';
        for (var j = 0; j < allEntries.length; j++) {
          (function (entry) {
            var li  = document.createElement('li');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dropdown-item amalgamous-dropdown-item';
            btn.textContent = entry.variant.title;
            if (entry.oos) {
              btn.style.textDecoration = 'line-through';
              btn.style.opacity = '0.45';
              btn.style.cursor = 'not-allowed';
              btn.disabled = true;
            } else {
              btn.addEventListener('click', function (e) {
                e.stopPropagation();
                if (entry.plans.length === 1) {
                  // Un seul plan : ajouter directement au panier
                  // Le dummy doit être dans le formulaire pour que handleAtcFormVariantClick
                  // puisse remonter jusqu'au form via closest()
                  var cardForm = card.querySelector('form');
                  var dummy = document.createElement('button');
                  dummy.setAttribute('data-variant-id', String(entry.variant.id));
                  if (entry.plans[0].isFake) {
                    saveFakeAtc(entry.variant.id, entry.plans[0]);
                    injectFakePropToForm(cardForm, entry.plans[0]);
                    dummy.setAttribute('data-selling-plan', '');
                    var _sp0 = cardForm && cardForm.querySelector('[name="selling_plan"]');
                    if (_sp0) { _sp0.disabled = true; _sp0.value = ''; }
                  } else {
                    dummy.setAttribute('data-selling-plan', String(entry.plans[0].planId));
                    if (cardForm) {
                      cardForm.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (el) { el.parentNode.removeChild(el); });
                      var _sp0r = cardForm.querySelector('[name="selling_plan"]');
                      if (_sp0r) { _sp0r.disabled = false; _sp0r.value = String(entry.plans[0].planId); }
                    }
                  }
                  dummy.style.display = 'none';
                  (cardForm || document.body).appendChild(dummy);
                  if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(dummy, e);
                  if (dummy.parentNode) dummy.parentNode.removeChild(dummy);
                } else {
                  buildLevel2(entry);
                }
              });
            }
            li.appendChild(btn);
            menu.appendChild(li);
          })(allEntries[j]);
        }
      }

      function buildLevel2(entry) {
        if (!menu) return;
        menu.innerHTML = '';
        // Bouton retour
        var backLi  = document.createElement('li');
        var backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'dropdown-item amalgamous-dropdown-item';
        backBtn.style.fontWeight = '700';
        backBtn.textContent = '← ' + entry.variant.title;
        backBtn.addEventListener('click', function (e) { e.stopPropagation(); buildLevel1(); });
        backLi.appendChild(backBtn);
        menu.appendChild(backLi);

        var divLi = document.createElement('li');
        divLi.innerHTML = '<hr class="dropdown-divider">';
        menu.appendChild(divLi);

        for (var k = 0; k < entry.plans.length; k++) {
          var pLi   = document.createElement('li');
          var pItem = document.createElement('button');
          pItem.type = 'button';
          pItem.className = 'dropdown-item amalgamous-dropdown-item';
          pItem.setAttribute('data-variant-id', String(entry.variant.id));
          if (entry.plans[k].isFake) {
            (function (v, p) {
              pItem.setAttribute('data-selling-plan', '');
              pItem.addEventListener('click', function (ev) {
                ev.stopPropagation();
                saveFakeAtc(v.id, p);
                var cardForm = card.querySelector('form');
                injectFakePropToForm(cardForm, p);
                var _spK = cardForm && cardForm.querySelector('[name="selling_plan"]');
                if (_spK) { _spK.disabled = true; _spK.value = ''; }
                var dummy = document.createElement('button');
                dummy.setAttribute('data-variant-id', String(v.id));
                dummy.setAttribute('data-selling-plan', '');
                dummy.style.display = 'none';
                (cardForm || document.body).appendChild(dummy);
                if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(dummy, ev);
                if (dummy.parentNode) dummy.parentNode.removeChild(dummy);
              });
            })(entry.variant, entry.plans[k]);
          } else {
            pItem.setAttribute('data-selling-plan', String(entry.plans[k].planId));
            (function (el, planId) {
              el.addEventListener('click', function (ev) {
                var frm = card.querySelector('form');
                if (frm) {
                  frm.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (n) { n.parentNode.removeChild(n); });
                  var _spR = frm.querySelector('[name="selling_plan"]');
                  if (_spR) { _spR.disabled = false; _spR.value = String(planId); }
                }
                if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(el, ev);
              });
            })(pItem, entry.plans[k].planId);
          }
          pItem.textContent = entry.plans[k].label;
          pLi.appendChild(pItem);
          menu.appendChild(pLi);
        }
      }

      buildLevel1();

      var dropBtnM = card.querySelector('[data-bs-toggle="dropdown"]');
      if (dropBtnM) dropBtnM.addEventListener('show.bs.dropdown', buildLevel1);

    } else {
      // ── Mono-variante ─────────────────────────────────────────────────────────
      var defaultVariant = variants[0];
      if (!defaultVariant || !defaultVariant.available) return; // BIS prend le relais

      var plans = getPlansForVariant(defaultVariant.id, product, fakePlanIds);
      if (!plans.length) return;

      // 1 variante + 1 seul plan : bouton direct, pas de dropdown
      if (plans.length === 1 && atcBtn) {
        // Supprimer le dropdown que le thème a pu générer via Liquid
        atcBtn.removeAttribute('data-bs-toggle');
        atcBtn.classList.remove('dropdown-toggle');
        var existingMenu = card.querySelector('.dropdown-menu');
        if (existingMenu) existingMenu.parentNode.removeChild(existingMenu);
        atcBtn.parentNode.classList.remove('dropdown', 'dropup');

        atcBtn.setAttribute('data-variant-id', String(defaultVariant.id));
        if (plans[0].isFake) {
          atcBtn.setAttribute('data-selling-plan', '');
          (function (v, p) {
            atcBtn.addEventListener('click', function (ev) {
              saveFakeAtc(v.id, p);
              var _frm = atcBtn.closest('form');
              injectFakePropToForm(_frm, p);
              var _spD = _frm && _frm.querySelector('[name="selling_plan"]');
              if (_spD) { _spD.disabled = true; _spD.value = ''; }
              if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(atcBtn, ev);
            });
          })(defaultVariant, plans[0]);
        } else {
          atcBtn.setAttribute('data-selling-plan', String(plans[0].planId));
          (function (planId) {
            atcBtn.addEventListener('click', function (ev) {
              var frm = atcBtn.closest('form');
              if (frm) {
                frm.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (n) { n.parentNode.removeChild(n); });
                var _spR = frm.querySelector('[name="selling_plan"]');
                if (_spR) { _spR.disabled = false; _spR.value = String(planId); }
              }
              if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(atcBtn, ev);
            });
          })(plans[0].planId);
        }
        var form1 = atcBtn.closest('form');
        if (form1 && !form1.querySelector('[name="selling_plan"]')) {
          var sp1 = document.createElement('input');
          sp1.type = 'hidden'; sp1.name = 'selling_plan'; sp1.value = '';
          form1.appendChild(sp1);
        }
        // Renommer après toutes les modifications DOM pour éviter que le thème réinitialise le texte
        renameBtn();
        addRibbon();
        return;
      }

      renameBtn();

      var menu2 = card.querySelector('.dropdown-menu');
      if (!menu2 && atcBtn) {
        menu2 = document.createElement('ul');
        menu2.className = 'dropdown-menu shadow w-100';
        atcBtn.parentNode.appendChild(menu2);
      }
      setupDropdown(menu2);

      function buildDropdownItems() {
        if (!menu2) return;
        menu2.innerHTML = '';
        for (var p = 0; p < plans.length; p++) {
          var li   = document.createElement('li');
          var item = document.createElement('button');
          item.className = 'dropdown-item amalgamous-dropdown-item';
          item.type = 'button';
          item.setAttribute('data-variant-id', String(defaultVariant.id));
          if (plans[p].isFake) {
            (function (v, pl) {
              item.setAttribute('data-selling-plan', '');
              item.addEventListener('click', function (ev) {
                ev.stopPropagation();
                saveFakeAtc(v.id, pl);
                var cardForm = card.querySelector('form');
                injectFakePropToForm(cardForm, pl);
                var _spP = cardForm && cardForm.querySelector('[name="selling_plan"]');
                if (_spP) { _spP.disabled = true; _spP.value = ''; }
                var dummy = document.createElement('button');
                dummy.setAttribute('data-variant-id', String(v.id));
                dummy.setAttribute('data-selling-plan', '');
                dummy.style.display = 'none';
                (cardForm || document.body).appendChild(dummy);
                if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(dummy, ev);
                if (dummy.parentNode) dummy.parentNode.removeChild(dummy);
              });
            })(defaultVariant, plans[p]);
          } else {
            item.setAttribute('data-selling-plan', String(plans[p].planId));
            (function (el, planId) {
              el.addEventListener('click', function (ev) {
                var frm = card.querySelector('form');
                if (frm) {
                  frm.querySelectorAll('[data-amalgamous-fake-prop]').forEach(function (n) { n.parentNode.removeChild(n); });
                  var _spR = frm.querySelector('[name="selling_plan"]');
                  if (_spR) { _spR.disabled = false; _spR.value = String(planId); }
                }
                if (window.handleAtcFormVariantClick) window.handleAtcFormVariantClick(el, ev);
              });
            })(item, plans[p].planId);
          }
          item.textContent = plans[p].label;
          li.appendChild(item);
          menu2.appendChild(li);
        }
      }

      buildDropdownItems();

      var dropBtn2 = card.querySelector('[data-bs-toggle="dropdown"]');
      if (dropBtn2) dropBtn2.addEventListener('show.bs.dropdown', buildDropdownItems);
    }

    // Ruban commun aux deux chemins
    addRibbon();
  }

  // Patch une carte catalogue en détectant les plans fake depuis le locale par défaut si besoin
  function patchCardAsync(card, product) {
    var fromLiquid = (card.dataset.fakePlanIds || '').split(',').filter(Boolean).map(Number);
    if (fromLiquid.length > 0) {
      patchCatalogCard(card, product, fromLiquid);
      return;
    }
    // Locale non-par-défaut : extraire le handle du lien produit et fetcher /products/[handle].js
    var link = card.querySelector('a[href*="/products/"]');
    var href = link && link.getAttribute('href');
    var m = href && href.match(/\/products\/([^?#/]+)/);
    var handle = m && m[1];
    if (!handle) { patchCatalogCard(card, product, []); return; }
    if (_fakePlanIdsByHandle[handle] !== undefined) {
      patchCatalogCard(card, product, _fakePlanIdsByHandle[handle]);
      return;
    }
    card.dataset.amalgamousCatalogFetching = '1';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = [];
        (data.selling_plan_groups || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (p) {
            if ((p.name || '').indexOf(FAKE_PLAN_MARKER) !== -1) ids.push(p.id);
          });
        });
        _fakePlanIdsByHandle[handle] = ids;
        card.removeAttribute('data-amalgamous-catalog-fetching');
        patchCatalogCard(card, product, ids);
      })
      .catch(function () {
        _fakePlanIdsByHandle[handle] = [];
        card.removeAttribute('data-amalgamous-catalog-fetching');
        patchCatalogCard(card, product, []);
      });
  }

  function bootCatalog() {
    injectStyles();

    function processCards() {
      document.querySelectorAll('li.product-item').forEach(function (card) {
        if (card.dataset.amalgamousCatalogPatched || card.dataset.amalgamousCatalogFetching) return;
        if (card.closest('#offcanvas-wishlist')) return;
        var pid = card.dataset.productId;
        var variantsJson = card.dataset.catalogVariants;
        var spGroupsJson = card.dataset.spGroups;
        if (!pid || !variantsJson || !spGroupsJson) { card.dataset.amalgamousCatalogPatched = '1'; return; }
        try {
          var spGroups = JSON.parse(spGroupsJson);
          if (!spGroups.length) { card.dataset.amalgamousCatalogPatched = '1'; return; }
          var variants = JSON.parse(variantsJson);
          patchCardAsync(card, { id: parseInt(pid, 10), variants: variants, selling_plan_groups: spGroups });
        } catch (e) { card.dataset.amalgamousCatalogPatched = '1'; }
      });
    }

    // Scan initial
    processCards();

    // Observer pour les produits chargés dynamiquement (infinite scroll / load more)
    var debounce = null;
    new MutationObserver(function (mutations) {
      var hasNewProducts = mutations.some(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.matches('li.product-item') || node.querySelector('li.product-item')) return true;
        }
        return false;
      });
      if (!hasNewProducts) return;
      clearTimeout(debounce);
      debounce = setTimeout(processCards, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ─── Search drawer : cartes produit dynamiques ───────────────────────────
  function bootSearchDrawer() {
    injectStyles();

    var container = document.getElementById('search-predictive');
    if (!container) return;

    function processCards() {
      container.querySelectorAll('li.product-item').forEach(function (card) {
        if (card.dataset.amalgamousCatalogPatched || card.dataset.amalgamousCatalogFetching) return;
        var pid = card.dataset.productId;
        var variantsJson = card.dataset.catalogVariants;
        var spGroupsJson = card.dataset.spGroups;
        if (!pid || !variantsJson || !spGroupsJson) { card.dataset.amalgamousCatalogPatched = '1'; return; }
        try {
          var spGroups = JSON.parse(spGroupsJson);
          if (!spGroups.length) { card.dataset.amalgamousCatalogPatched = '1'; return; }
          var variants = JSON.parse(variantsJson);
          patchCardAsync(card, { id: parseInt(pid, 10), variants: variants, selling_plan_groups: spGroups });
        } catch (e) { card.dataset.amalgamousCatalogPatched = '1'; }
      });
    }

    var debounce = null;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(processCards, 150);
    }).observe(container, { childList: true, subtree: true });
  }

  // ─── API publique ─────────────────────────────────────────────────────────
  // Expose le plan actuellement sélectionné pour le produit de BASE affiché sur
  // la page. Utilisé par d'autres blocs (ex: "Set complet") qui ne peuvent pas
  // avoir leur propre plan de vente (limitation Shopify : pas de selling plan
  // sur les produits Bundle) mais doivent quand même afficher au panier les
  // mêmes informations (garantie, date d'expédition...) via une propriété de
  // ligne, comme le fait déjà le mécanisme des plans "fake" ci-dessus.
  window.AmalgamousPreorderAPI = {
    getCurrentPlan: function () {
      var variantId = getCurrentVariantId();
      if (!variantId) return null;
      var plans = getPlansForVariant(variantId);
      if (!plans.length) return null;
      var selected = null;
      for (var i = 0; i < plans.length; i++) {
        if (plans[i].planId === _selectedPlanId) { selected = plans[i]; break; }
      }
      if (!selected) selected = plans[0];
      return { label: selected.label, name: selected.name, description: selected.description };
    }
  };

  // ─── Lancement ────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); bootCart(); bootCatalog(); bootSearchDrawer(); });
  } else {
    boot();
    bootCart();
    bootCatalog();
    bootSearchDrawer();
  }

  // Rechargement section dans l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SEL_FORM)) {
      productData = null;
      boot();
    }
  });

})();
